export default "__VITE_ASSET__b1b9e130__"